import React from 'react'

const ArrowDown = () => {
  return (
    <svg height="20" width="20" viewBox="0 0 44 44" className="arrowDown">
      <path d="M22 0C9.85 0 0 9.85 0 22s9.85 22 22 22 22-9.85 22-22C43.987 9.856 34.144.013 22 0zm12.819 17.628l-10.33 13.467a3.137 3.137 0 0 1-4.979 0L9.181 17.628a2.291 2.291 0 1 1 3.617-2.815l.02.026 8.819 11.497a.457.457 0 0 0 .733 0l8.819-11.497a2.292 2.292 0 0 1 3.657 2.763l-.02.026h-.007z" />
    </svg>
  )
}

export default ArrowDown
